import { render, staticRenderFns } from "./CarrierFilters.vue?vue&type=template&id=8152417e&scoped=true"
import script from "./CarrierFilters.vue?vue&type=script&lang=ts"
export * from "./CarrierFilters.vue?vue&type=script&lang=ts"
import style0 from "./CarrierFilters.vue?vue&type=style&index=0&id=8152417e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8152417e",
  null
  
)

export default component.exports